import { IEmptyObject } from "@Components/shared/types";
import Result from "@Core/Result";
import { ServiceBase } from "@Core/ServiceBase";
import {
    IComplianceDetails,
    IComplianceMeta,
    IComplianceReportDetails,
    IComplianceStatus,
} from "@Models/IComplianceDetails";
import { IEntity } from "@Models/IEntity";

export default class ComplianceService extends ServiceBase {
    /**
     * Submit a data access or data deletion request.
     * @param userId
     * @param type
     */
    public async create(
        userId: string,
        type: IComplianceDetails["type"],
        model?: IComplianceMeta
    ): Promise<Result<IEntity>> {
        return await this.requestJson({
            url: `/api/Compliance/Create/${userId}?type=${type}`,
            method: "POST",
            data: model ?? {},
        });
    }

    /**
     * Update the status of a request.
     * @param complianceId
     * @param status
     */
    public async update(complianceId: string, status: string): Promise<Result<IEmptyObject>> {
        return await this.requestJson({
            url: `/api/Compliance/Update?compliance=${complianceId}&status=${status}`,
            method: "PATCH",
        });
    }

    /**
     * Get all compliance requests.
     */
    public async getAll(): Promise<Result<IComplianceDetails[]>> {
        return await this.requestJson({
            url: `/api/Compliance/GetAll`,
            method: "GET",
        });
    }

    /**
     * Get the latest compliance report for the user.
     * @param user
     */
    public async getReport(user: string): Promise<Result<IComplianceReportDetails>> {
        return await this.requestJson({
            url: `/api/Compliance/GetReport/${user}`,
            method: "GET",
        });
    }

    /**
     * Get the status of the most recent report request for the user.
     * @param user
     */
    public async getRequestStatus(user: string): Promise<Result<IComplianceStatus>> {
        return await this.requestJson({
            url: `/api/Compliance/GetRequestStatus/${user}`,
            method: "GET",
        });
    }

    /**
     * Delete a request.
     * @param complianceId
     */
    public async delete(complianceId: string): Promise<Result<IEmptyObject>> {
        return await this.requestJson({
            url: `/api/Compliance/Delete?compliance=${complianceId}`,
            method: "DELETE",
        });
    }
}
